import { useContext, useRef, useState } from "react"
import { OffCanvas } from "../OffCanvas"
import { GlobalContext } from "../../context/GlobalContext"
import { OrderContext } from "../../context/OrderContext"
import { useDispatch, useSelector } from "react-redux"
import { useSWRConfig } from "swr"
import { CLEAR_SELECT_ORDER, UPDATE_ORDER, UPDATE_SELECT_ORDER } from "../../stores/reducers/OrderReducers"
import { Btn } from "../Btn"
import { IoIosArrowForward } from "react-icons/io"
import { BsCreditCard2Back } from "react-icons/bs"
import { LuCirclePlus, LuPackageCheck, LuPackagePlus } from "react-icons/lu"
import { maskCurrency } from "../../utils/utils"
import { DateTime } from "luxon"
import * as T from "../Tables/styles"
import { Toast } from "../../utils/Toast"
import { api } from "../../api/api"
import { FaCheck } from "react-icons/fa"
import { IoClose } from "react-icons/io5"
import { FiPlusCircle, FiUserPlus } from "react-icons/fi"
import { CustomItemCard } from "../CustomItemCard"
import { FaBoxesStacked, FaRegTrashCan } from "react-icons/fa6"
import { HiOutlinePrinter } from "react-icons/hi"
import { sendPrint } from "../../reporting/print"
import _ from "lodash"
import { AllPayments } from "../Modals/Orders/components/AllPayments"
import { NewAddProduct } from "../Modals/Orders/components/NewAddProduct"
import { CustomerForm } from "../Forms/Customer"
import { MdClose, MdTableRestaurant } from "react-icons/md"
import { DELETE_COMMAND_TABLE, } from "../../stores/reducers/TableReducers"
import './style.css'
import { OrderOverview } from "./OrderOverview"
import { NewCommandDialog } from "./NewCommandDialog"

let isRequest = false

export function TableOffCanvasOrder({ isOffCanvasOpen, toggleOffCanvas }) {
  const { isAccess } = useContext(GlobalContext)
  const { orders, selectOrder, orderScreen,
    changeOrderScreen, addProductsToConfirmationList, listProductsAdd,
    setListProductsAdd, calculateTotal, update } = useContext(OrderContext)

  const [showDeleteCommand, setShowDeleteComman] = useState(null)

  const [isNewCommand, setIsNewCommand] = useState(false)
  const [isNewOrderTable, setIsNewOrderTable] = useState(false)
  const [customerDirty, setCustomerDirty] = useState(false)
  const commandCode = useRef("")

  const dispatch = useDispatch()

  const selectTable = useSelector(state => state.table.table)
  const order = useSelector(state => state.order?.orderSelect)

  const { mutate } = useSWRConfig()

  async function confirmDiscardCustomerChanges() {
    if (!orderScreen.customer || !customerDirty) return true

    return Toast.confirm(
      'Existem alterações no cliente que não foram salvas. Deseja descartá-las?',
      'Continuar editando',
      'Descartar'
    )
  }

  async function handleChangeOrderScreen() {
    if (!await confirmDiscardCustomerChanges()) return

    if (orderScreen.listProducts || orderScreen.customer || orderScreen.closeOrder) {
      setCustomerDirty(false)
      changeOrderScreen('default')
    } else if (orderScreen.addProducts) {
      changeOrderScreen('listProducts')
    }
  }

  function calcTotalTable() {
    const ids = selectTable?.commands?.map(e => e.idOrder) || []
    return orders.filter(e => ids.includes(e.id))?.reduce((prev, command) => prev += command.total, 0)
  }

  function calcPermanenciaTable() {
    const auxCommand = _.orderBy(selectTable?.commands, 'cratedAt', 'asc')[0]

    if (!auxCommand) return

    const startedAtDate = auxCommand.startedAt ?? auxCommand.createdAt
    const finishedAtDate = auxCommand.finishedAt || DateTime.local().toISO()

    const startedAt = DateTime.fromISO(startedAtDate).toLocal()
    const finishedAt = finishedAtDate
      ? DateTime.fromISO(finishedAtDate).toLocal()
      : DateTime.local()

    const duration = finishedAt.diff(startedAt)

    const totalMs = duration.toMillis()

    const totalDuration = DateTime.fromMillis(totalMs).diff(DateTime.fromMillis(0), ['days', 'hours', 'minutes', 'seconds']).toObject()

    const formatted = `${totalDuration.days > 0 ? totalDuration.days + 'd ' : ''}${String(totalDuration.hours).padStart(2, '0')}:${String(totalDuration.minutes).padStart(2, '0')}`

    return formatted
  }

  async function openOrder(command) {
    await selectOrder(command.idOrder)
    await mutate('/product-order/products/not-seen')

  }

  async function addNewCommand(code) {
    if (!selectTable?.id || !code) {
      Toast.warning('Para adicionar uma comanda é necessário o código')
      return
    }

    const response = await api.post('/commands', {
      idTable: selectTable?.id, code
    })

    Toast.success()

    await Promise.all([
      openOrder(response.data),
      mutate('list-tables'),
    ])
  }

  async function removeProduct(id) {
    const newOrder = {
      ...order,
      productsOrders: order?.productsOrders.filter((e) => e.id !== id),
    }

    const totalUpdated = calculateTotal(newOrder)

    const payload = {
      ...newOrder,
      total: totalUpdated
    }

    await sendPrint('cancel-product-order', { product: order?.productsOrders.find((e) => e.id === id) }, order?.id)

    dispatch(UPDATE_ORDER(payload))

    await update(false, true, payload)
  }

  async function addProduct(dataProducts = [], { print }) {
    try {
      if (!Array.isArray(dataProducts) || dataProducts.length === 0) {
        return;
      }

      if (isRequest) {
        return Toast.warning('Aguarde um momento, estamos salvando a informação.')
      }

      if (order?.status === 'cancelado') return Toast.warning('Comanda cancelada, não é possível realizar ações para a mesma')

      isRequest = true

      dataProducts = dataProducts.map((v) => {
        return {
          ...v,
          isPrinted: false,
          isSeen: false
        }
      })

      const newProducts = [...order?.productsOrders ?? [], ...dataProducts]

      const newOrder = {
        id: order?.id,
        productsOrders: newProducts
      }

      const totalUpdated = calculateTotal(newOrder)

      const payload = {
        ...newOrder,
        total: totalUpdated
      }

      dispatch(UPDATE_ORDER(payload))
      const next = await update(false, true, payload)

      isRequest = false

      // se não for continuar pq deu erro em algo pra que vou imprimir essa buceta?
      if (next) {
        if (print) {
          await sendPrint('product-order', { dataProducts }, order?.id)
        }
      }

      setListProductsAdd([])
    } catch (error) {
      isRequest = false
    }
  }

  function canculateUnitProduct(productOrder) {
    let additinalTotals = 0

    if (Object.keys(productOrder.additinal).length) {
      additinalTotals = Object.keys(productOrder.additinal).reduce((prev, key) => {
        const enabledUseHighestItemPrice = productOrder.additinal[key].find(e => !!e?.useHighestItemPrice)

        if (enabledUseHighestItemPrice) {
          const _aux = _.orderBy(productOrder.additinal[key], 'pricing', 'desc')[0]

          return prev + (_aux.pricing * _aux.quantity)
        }

        const value = productOrder.additinal[key].reduce((prevAditional, current) => prevAditional += (current.pricing * current.quantity), 0)

        prev += value
        return prev
      }, 0)
    }

    return productOrder.pricing + additinalTotals
  }

  async function closeOrCancelOrder(cancel = false) {
    const confirmation = await Toast.confirm(`Deseja ${cancel ? 'Cancelar' : 'Finalizar'} o pedido?`, "Não", "Sim")

    if (confirmation) {

      if (cancel) {
        if (isAccess('pedidos', 'cancelar_pedido')) {
          await sendPrint('cancel-order', {}, order?.id)
          await api.put('/orders/' + order?.id, { status: 'cancelado' })
        } else {
          return Toast.warning('Você não tem permissão para cancelar pedido')
        }
      } else {
        if (isAccess('pedidos', 'update')) {
          await api.put('/orders/' + order?.id, { status: 'finalizado' })
        } else {
          return Toast.warning('Você não tem permissão para atualizar pedido')
        }
      }

      Toast.success(`Pedido ${cancel ? 'cancelado' : 'finalizado'} com sucesso`)

      changeOrderScreen('default')

      await mutate('list-tables')
      return
    }
  }

  async function setSeen(id) {
    await api.put('/product-order/set-seen-printed', { ids: [id] })

    dispatch(UPDATE_SELECT_ORDER({
      productsOrders: order?.productsOrders.map(x => {
        if (x.id === id) {
          return {
            ...x,
            isSeen: true
          }
        }
        return x
      })
    }))
  }

  async function removeCommand(id) {
    await api.delete('/commands/' + id)
    Toast.success('Comanda deletada!')
    dispatch(DELETE_COMMAND_TABLE(id))
  }

  async function closeTable(id) {
    await api.post('/tables/close-table', { id })
    Toast.success()
  }

  function clearAll() {
    dispatch(CLEAR_SELECT_ORDER())
    toggleOffCanvas()
    changeOrderScreen('default')
    setListProductsAdd([])
    setShowDeleteComman(null)
    setIsNewCommand(false)
    setCustomerDirty(false)
  }

  async function requestClose() {
    if (!await confirmDiscardCustomerChanges()) return

    if (listProductsAdd.length > 0) {
      const confirmation = await Toast.confirm('Existem itens ainda não confirmados. Deseja descartá-los?', 'Continuar editando', 'Descartar')
      if (!confirmation) return
    }

    clearAll()
  }

  const tableSidebar = (
    <>
      <section className="ifood-section standard-table-summary">
        <div className="ifood-section-title"><MdTableRestaurant size={18} /><h6>Resumo da mesa</h6></div>
        <div className="standard-table-totals">
          <div><span>Total da mesa</span><strong>{maskCurrency(calcTotalTable())}</strong></div>
          <div><span>Permanência</span><strong>{calcPermanenciaTable() || '--:--'}</strong></div>
        </div>
        {selectTable?.id && !selectTable?.available && isAccess() !== 'garcom' && (
          <button type="button" className="standard-close-table" onClick={async () => {
            const confirmation = await Toast.confirm('Deseja realmente fechar mesa?', 'Não', 'Sim')
            if (!confirmation) return
            await closeTable(selectTable.id)
            await mutate('list-tables')
            clearAll()
          }}>Fechar mesa</button>
        )}
      </section>

      <section className="ifood-section standard-commands-panel">
        <div className="ifood-section-title">
          <FaBoxesStacked size={17} />
          <h6>Comandas</h6>
          <span>{selectTable?.commands?.length || 0}</span>
        </div>

        <div className="standard-command-actions">
          {selectTable?.commands?.length === 0 && (
            <button type="button" className="new-table-order" onClick={async () => {
              if (!isAccess('mesas', 'adicionar_comanda')) return Toast.warning('Você não tem permissão para criar um pedido de mesa')
              const confirmation = await Toast.confirm('Deseja criar um pedido nesta mesa?', 'Não', 'Sim')
              if (confirmation) await addNewCommand(selectTable.id)
            }}><FiPlusCircle /> Novo pedido</button>
          )}
          <button type="button" className="new-command" onClick={() => setIsNewCommand(true)}><FiPlusCircle /> Nova comanda</button>
        </div>

        <div className="standard-command-list">
          {selectTable?.commands?.map(command => (
            <button type="button" key={command.id} className={command.idOrder === order?.id ? 'active' : ''} onClick={() => openOrder(command)}>
              <div><small>Comanda</small><strong>{command.code.length < 36 ? command.code : 'Pedido'}</strong></div>
              <div><strong>{maskCurrency(orders.find(item => item.id === command.idOrder)?.total || 0)}</strong><small>{command.totalItems || 0} itens</small></div>
              {isAccess() !== 'garcom' && <span role="button" tabIndex={0} onClick={async (event) => {
                event.stopPropagation()
                const confirmation = await Toast.confirm('Deseja excluir esta comanda?', 'Não', 'Sim')
                if (confirmation) await removeCommand(command.id)
              }}><FaRegTrashCan /></span>}
            </button>
          ))}
        </div>
      </section>
    </>
  )

  return (
    <>
      <NewCommandDialog
        open={isNewCommand}
        onClose={() => setIsNewCommand(false)}
        onConfirm={addNewCommand}
      />
      <OffCanvas
        isModal
        width={'1180px'}
        paddingBody={orderScreen ? '0' : '1rem'}
        expanded={isOffCanvasOpen}
        onClose={requestClose}
        titleIcon={<MdTableRestaurant size={21} />}
        title={orderScreen.default ? (selectTable?.name ? `Mesa ${selectTable.name}` : 'Mesa') : orderScreen.listProducts || orderScreen.addProducts ? 'Adicionar itens' : orderScreen.customer ? 'Cliente e endereço' : 'Pagamento'}
        subtitle={orderScreen.default ? (selectTable?.commands?.length ? `${selectTable.commands.length} ${selectTable.commands.length > 1 ? 'comandas' : 'comanda'} · selecione a comanda que deseja editar` : 'Nenhuma comanda lançada') : orderScreen.customer ? 'Edite os dados e clique em Salvar alterações' : 'As alterações são aplicadas à comanda selecionada'}
        clearValues={() => console.log('clearValues')}
        footer={
          <div className="order-editor-footer">
            <div>
              {!orderScreen.default && (
                <Btn
                  text={'Voltar'}
                  click={() => handleChangeOrderScreen()}
                  icon={<IoIosArrowForward size={18} color="#94a3b8" style={{ transform: 'rotateY(180deg)' }} />}
                  leftIcon
                />
              )}
            </div>

            <div>
              {orderScreen.default && (
                <div style={{ display: 'flex', gap: 10, justifyContent: 'space-between', }}>
                  {order?.id && <Btn
                    text={'Imprimir pedido'}
                    icon={<HiOutlinePrinter size={18} />}
                    leftIcon
                    click={() => sendPrint('order', {}, order?.id)}
                    width={170}
                  />}

                  {isAccess() !== 'garcom' && (
                    <Btn
                    text={'Fechar comanda / pagamento'}
                      backgroundColor='#ff6200'
                      hoverColor='#d55302'
                      color='white'
                      icon={<BsCreditCard2Back size={18} color="white" />}
                      leftIcon
                      disabled={(!order || ['cancelado', 'finalizado'].includes(order?.status)) ? true : false}
                      click={() => changeOrderScreen('closeOrder')}
                      width={200}
                    />
                  )}
                </div>
              )}

              {orderScreen.addProducts && (
                <Btn
                  text={'Adicionar produto'}
                  backgroundColor='#ff6200'
                  hoverColor='#d55302'
                  color='white'
                  icon={<LuPackagePlus size={18} color="white" />}
                  leftIcon
                  disabled={!order ? true : false}
                  click={addProductsToConfirmationList}
                />
              )}

              {orderScreen.closeOrder && (
                <Btn
                    text={'Finalizar comanda'}
                  backgroundColor='#ff6200'
                  hoverColor='#d55302'
                  color='white'
                  icon={<LuPackagePlus size={18} color="white" />}
                  leftIcon
                  disabled={!order ? true : false}
                  click={() => closeOrCancelOrder()}
                />
              )}
            </div>

            {/* <Btn
              text={'Imprimir Prévia'}
              disabled={!selectTable?.commands?.length ? true : false}
            /> */}
          </div>
        }
      >
        {orderScreen.default && (
          <OrderOverview
            order={order}
            pendingProducts={listProductsAdd}
            calculateProductTotal={canculateUnitProduct}
            canEdit={Boolean(order?.id) && !['cancelado', 'finalizado'].includes(order?.status)}
            onAddItems={() => changeOrderScreen('listProducts')}
            onEditCustomer={() => changeOrderScreen('customer')}
            onOpenPayments={() => changeOrderScreen('closeOrder')}
            onConfirmPending={() => addProduct(listProductsAdd, { print: true })}
            onRemovePending={async (id) => {
              const confirmation = await Toast.confirm('Deseja remover este item?', 'Não', 'Sim')
              if (confirmation) setListProductsAdd(listProductsAdd.filter(product => product.id !== id))
            }}
            onRemoveProduct={async (id) => {
              if (isAccess() === 'garcom') return Toast.warning('Você não tem acesso para remover produto')
              const confirmation = await Toast.confirm('Deseja remover este item da comanda?', 'Não', 'Sim')
              if (confirmation) await removeProduct(id)
            }}
            onPrintProduct={(product) => sendPrint('product-order', { dataProducts: [product] }, order?.id)}
            onSetSeen={setSeen}
            sidebarHeader={tableSidebar}
            hideSummary
            tableMode
          />
        )}

        {false && orderScreen.default ? (
          <div className="order-editor-default table-order-editor">
            <div style={{ padding: '0 1rem' }}>
              <div style={{ padding: '1rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center', backgroundColor: '#121428', borderRadius: '8px', }}>
                <div>
                  <p style={{ color: '#94a3b8', fontSize: '0.85rem', fontWeight: '700' }}>TOTAL DA MESA</p>
                  <p style={{ color: 'white', fontSize: '1.5rem', fontWeight: '700' }}>{maskCurrency(calcTotalTable())}</p>
                </div>

                <div>
                  <p style={{ color: '#94a3b8', fontSize: '0.85rem', fontWeight: '700' }}>PERMANÊNCIA</p>
                  <p style={{ color: 'white', fontSize: '1rem', fontWeight: '700', textAlign: 'end' }}>{calcPermanenciaTable()}</p>
                </div>
              </div>

              {selectTable?.id && Boolean(selectTable?.available) === false && isAccess() !== 'garcom' && (
                <div>
                  <button className="btn btn-primary mt-2" onClick={async () => {
                    const confirmation = await Toast.confirm('Deseja realmente fechar mesa?', 'Não', 'Sim')

                    if (confirmation) {
                      await closeTable(selectTable.id)
                      await mutate('list-tables')
                      clearAll()
                    }

                  }}>Fechar mesa</button>
                </div>
              )}
            </div>

            <>
              <div>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '0 1rem', height: '23px' }}>
                  <p style={{ color: '#94a3b8', fontSize: '0.9rem', fontWeight: '600' }}>COMANDAS</p>

                  {/* {isNewCommand ? (
                  <T.ContentNewComand>
                    <input
                      ref={commandCode}
                      style={{ height: '30px', minHeight: '30px', width: '200px', borderRadius: '8px', boxShadow: 'none' }}
                      maxLength={100}
                      className="form-control form-control-sm" type="text"
                      placeholder="Cód. Comanda"
                    />

                    <div className="contentCancelAction" onClick={() => addNewCommand(commandCode.current.value)}>
                      <FaCheck size={14} />
                    </div>

                    <div className="contentCancelAction" onClick={() => setIsNewCommand(false)}>
                      <IoClose size={14} />
                    </div>
                  </T.ContentNewComand>
                ) : (
                  <T.ContentNewComand onClick={() => setIsNewCommand(true)}>
                    <FiPlusCircle size={14} />
                    <p style={{ fontSize: '0.9rem', fontWeight: '600', lineHeight: '0' }}>Nova Comanda</p>
                  </T.ContentNewComand>
                )} */}

                  <>
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 20 }}>
                      {isNewOrderTable ? (
                        <T.ContentNewComand>

                          <p style={{ fontSize: '1.3rem' }}>Você confirma essa ação?</p>
                          <br />
                          <div className="contentCancelAction" onClick={async () => {
                            await addNewCommand(selectTable.id, selectTable.id)
                            setIsNewOrderTable(false)
                          }}>
                            <FaCheck size={14} />
                          </div>

                          <div className="contentCancelAction" onClick={() => setIsNewOrderTable(false)}>
                            <IoClose size={14} />
                          </div>
                        </T.ContentNewComand>
                      ) : isNewCommand === false && !selectTable?.commands?.find(x => x.code === selectTable.id)?.id && selectTable?.commands?.length === 0 && (
                        <T.ContentNewComand onClick={async () => {
                          if (!isAccess('mesas', 'adicionar_comanda')) {
                            return Toast.warning('Você não tem permissão para criar um pedido de mesa')
                          }

                          if (selectTable.id) {
                            setIsNewOrderTable(true)
                          }
                        }}>
                          <FiPlusCircle size={14} />
                          <p style={{ fontSize: '0.9rem', fontWeight: '600', lineHeight: '0' }}>Novo Pedido</p>
                        </T.ContentNewComand>
                      )
                      }

                      {isNewCommand ? (
                        <T.ContentNewComand>
                          <input
                            ref={commandCode}
                            style={{ height: '20px', minHeight: '20px', width: '200px', borderRadius: '8px', boxShadow: 'none' }}
                            maxLength={100}
                            className="form-control form-control-sm" type="text"
                            placeholder="Cód. Comanda"
                          />

                          <div className="contentCancelAction" onClick={async () => {
                            await addNewCommand(commandCode.current.value)
                            setIsNewCommand(false)
                          }}>
                            <FaCheck size={14} />
                          </div>

                          <div className="contentCancelAction" onClick={() => setIsNewCommand(false)}>
                            <IoClose size={14} />
                          </div>
                        </T.ContentNewComand>
                      ) : isNewOrderTable === false && <T.ContentNewComand onClick={() => {
                        setIsNewCommand(true)
                      }}>
                        <FiPlusCircle size={14} />
                        <p style={{ fontSize: '0.9rem', fontWeight: '600', lineHeight: '0' }}>Nova Comanda</p>
                      </T.ContentNewComand>}
                    </div>
                  </>
                </div>

                <T.ContentCards>
                  {selectTable?.commands.map((command, indiceCommand) => (
                    <CustomItemCard
                      key={command.id}
                      margin={'10.5px 0 0 0'}
                      minWidth={'140px'}
                      maxWidth={'140px'}
                      isOverflow={false}
                      active={command.idOrder === order?.id}
                      click={() => openOrder(command)}
                    >
                      {showDeleteCommand === command.id ? (
                        <div style={{ width: '100%', height: '56px', maxHeight: '56px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '0.5rem' }}>
                          <p style={{ fontSize: '10.7px', fontWeight: 600, color: '#bd4800' }}>EXCLUIR COMANDA ?</p>

                          <div style={{ display: 'flex', gap: '0.8rem' }}>
                            <button className="btn btn-primary" style={{ maxWidth: '57px', backgroundColor: '#f8fafc', border: 'solid 1px #dae2f0', color: 'rgb(113, 125, 143)', height: '25px' }} onClick={() => setShowDeleteComman(null)}>Não</button>
                            <button className="btn btn-primary" style={{ maxWidth: '57px', height: '25px' }} onClick={(e) => removeCommand(command.id)} >Sim</button>
                          </div>
                        </div>
                      ) : (
                        <>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', justifyContent: 'space-between' }}>
                            <p className="title">
                              {command.code.length === 36 && '-'}
                              {command.code.length < 36 && (`${command.code}`)}
                            </p>

                            {isAccess() !== 'garcom' && <FaRegTrashCan size={18} color="#ff6200" onClick={() => setShowDeleteComman(command.id)} />}
                          </div>

                          <p className="subtitle">{maskCurrency(orders.find(e => e.id === command.idOrder)?.total || 0)}</p>
                          <p className="totalItems"><FaBoxesStacked style={{ marginRight: '0.3rem' }} /> {command?.totalItems || 0} Itens</p>
                        </>
                      )}
                    </CustomItemCard>
                  ))}
                </T.ContentCards>
              </div>

              <div style={{ padding: '0px 1rem' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', gap: '1rem' }}>
                  {!['cancelado', 'finalizado'].includes(order?.status) && (
                    <Btn text={'Lançar Itens'} icon={<LuCirclePlus size={18} color="#ff6200" />} leftIcon click={() => changeOrderScreen('listProducts')} />
                  )}

                  <Btn text={'Imprimir Prévia'} icon={<HiOutlinePrinter size={18} color="#334155" />} leftIcon click={() => {
                    sendPrint('order', {}, order?.id)
                  }} />
                </div>

                <CustomItemCard
                  titleWeight="500"
                  maxWidth="auto"
                  minWidth="auto"
                  width="100%"
                  margin="2rem 0 0 0"
                  display="flex"
                  flexDirection="row"
                  justifyContent="space-between"
                  alignItems="center"
                  backgroundColor="#f8fafc"
                  click={() => changeOrderScreen('customer')}
                >
                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '1rem',
                  }}>
                    <div style={{
                      width: 35,
                      height: 35,
                      borderRadius: '50%',
                      backgroundColor: 'white',
                      border: '1px solid #dae2f0',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}>
                      <FiUserPlus size={20} color="#94a3b8" />
                    </div>

                    <div>
                      <p className="title">Cliente</p>
                      <p className="subtitle">{order?.name}</p>
                    </div>
                  </div>

                  <div>
                    <IoIosArrowForward size={18} color="#94a3b8" />
                  </div>
                </CustomItemCard>

                {listProductsAdd?.length && !['cancelado', 'finalizado'].includes(order?.status) ? (
                  <>
                    <div style={{ width: '100%', marginTop: '2rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <p style={{ color: 'red', fontSize: '0.9rem', fontWeight: '600' }}>ITENS NÃO CONFIRMADOS ({listProductsAdd?.length || 0})</p>

                      <T.ContentNewComand $textColor={'#0db60d'} $hoverColor={'#128a12'} onClick={async () => await addProduct(listProductsAdd, { print: true })}>
                        <LuPackageCheck size={14} />
                        <p style={{ fontSize: '0.9rem', fontWeight: '600' }}>Confirmar Todos</p>
                      </T.ContentNewComand>
                    </div>

                    {_.orderBy(listProductsAdd, (a) => a.isSeen, 'asc')?.map(prod => (
                      <CustomItemCard
                        key={prod.id}
                        titleWeight="500"
                        maxWidth='auto'
                        minWidth='auto'
                        margin="1.3rem 0 0 0"
                        width="100%"
                        display="flex"
                        flexDirection="row"
                        alignItems="center"
                        justifyContent="space-between"
                        onConfirm={() => setListProductsAdd(listProductsAdd.filter((e) => e.id !== prod.id))}
                        initIcon={<FaRegTrashCan />}
                      >
                        <div style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '1rem',
                        }}>
                          <div style={{
                            width: 28,
                            height: 28,
                            borderRadius: '8px',
                            backgroundColor: '#f8fafc',
                            border: '1px solid #f1f5f9',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            fontWeight: 700,
                            color: '#475569'
                          }}>
                            {prod.quantity}x
                          </div>

                          <div>
                            <p className="subtitle" style={{ fontWeight: 600, color: '#334155' }}>{prod.name}</p>
                            <p className="subtitle" style={{ fontWeight: 500, fontSize: '0.8rem', color: 'rgb(148, 163, 184)' }}>Unitário: <span style={{ fontWeight: 600 }}>{maskCurrency(prod.pricing)}</span></p>

                            {Object.keys(prod.additinal).length ? (
                              <div style={{ marginTop: '0.1rem' }}>
                                {Object.keys(prod.additinal).map(additinalName => {
                                  const additinals = prod?.additinal[additinalName]
                                  const _aux = _.orderBy(additinals, 'pricing', 'desc')[0]

                                  return additinals.map((additinal, idx) => {
                                    const strikethrough = _aux.useHighestItemPrice && _aux.id !== additinal.id

                                    return (
                                      <div style={{ display: 'flex', gap: '0.3rem', alignItems: 'center' }} key={idx}>
                                        <p className="subtitle" style={{ fontWeight: 500, fontSize: '0.85rem', color: 'rgb(148, 163, 184)' }}>
                                          <span style={{ color: '#fead15' }}>+{additinal.quantity}</span>
                                        </p>

                                        <p className="subtitle" style={{ fontWeight: 400, fontSize: '0.85rem', color: 'rgb(148, 163, 184)' }}>
                                          {additinal.name}
                                        </p>

                                        <p className="subtitle" style={{ textDecoration: strikethrough ? 'line-through' : 'none', fontWeight: 400, fontSize: '0.85rem', color: 'rgb(148, 163, 184)' }}>
                                          {maskCurrency(additinal.pricing)}
                                        </p>
                                      </div>
                                    )
                                  })
                                })}
                              </div>
                            ) : ""}
                          </div>
                        </div>

                        <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                          <p className="subtitle" style={{ fontWeight: 700 }}>{maskCurrency(canculateUnitProduct(prod) * prod.quantity)}</p>

                          <HiOutlinePrinter size={15} color="#7176f8" onClick={async () => await sendPrint('product-order', { dataProducts: [prod] }, order?.id)} />
                        </div>
                      </CustomItemCard>
                    ))}
                  </>
                ) : ""}

                <div style={{ width: '100%', marginTop: '2rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <p style={{ color: '#94a3b8', fontSize: '0.9rem', fontWeight: '600' }}>ITENS ({order?.productsOrders?.length || 0})</p>

                  {/* <T.ContentNewComand onClick={async () => await sendPrint('product-order', { dataProducts: order?.productsOrders }, order?.id)}>
                      <HiOutlinePrinter size={14} />
                      <p style={{ fontSize: '0.9rem', fontWeight: '600', lineHeight: '0' }}>Imprimir Produtos</p>
                    </T.ContentNewComand> */}
                </div>

                {order?.productsOrders?.map(productOrder => (
                  <CustomItemCard
                    key={productOrder.id}
                    titleWeight="500"
                    maxWidth='auto'
                    minWidth='auto'
                    margin="1.3rem 0 0 0"
                    width="100%"
                    display="flex"
                    flexDirection="row"
                    alignItems="center"
                    justifyContent="space-between"
                    onConfirm={() => {
                      if (isAccess() === 'garcom') {
                        return Toast.warning('Você não tem acesso para remover produto')
                      }

                      removeProduct(productOrder.id)
                    }}
                    initIcon={<FaRegTrashCan />}
                  >
                    <div style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '1rem',
                    }}>
                      <div style={{
                        width: 28,
                        minWidth: 28,
                        height: 28,
                        minHeight: 28,
                        borderRadius: '8px',
                        backgroundColor: '#f8fafc',
                        border: '1px solid #f1f5f9',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        fontWeight: 700,
                        color: '#475569'
                      }}>
                        {productOrder.quantity}x
                      </div>

                      <div>
                        <p className="subtitle" style={{ fontWeight: 600, color: '#334155' }}>{productOrder.name}</p>
                        <p className="subtitle" style={{ fontWeight: 500, fontSize: '0.9rem', color: 'rgb(148, 163, 184)' }}>Unitário: <span style={{ fontWeight: 600 }}>{maskCurrency(productOrder.pricing)}</span></p>

                        {Object.keys(productOrder.additinal).length ? (
                          <div style={{ marginTop: '0.1rem' }}>
                            {Object.keys(productOrder.additinal).map(additinalName => {
                              const additinals = productOrder?.additinal[additinalName]
                              const _aux = _.orderBy(additinals, 'pricing', 'desc')[0]

                              return additinals.map((additinal, idx) => {
                                const strikethrough = _aux.useHighestItemPrice && _aux.id !== additinal.id

                                return (
                                  <div style={{ display: 'flex', gap: '0.3rem', alignItems: 'center' }} key={idx}>
                                    <p className="subtitle" style={{ fontWeight: 500, fontSize: '0.85rem', color: 'rgb(148, 163, 184)' }}>
                                      <span style={{ color: '#fead15' }}>+{additinal.quantity}</span>
                                    </p>

                                    <p className="subtitle" style={{ fontWeight: 400, fontSize: '0.85rem', color: 'rgb(148, 163, 184)' }}>
                                      {additinal.name}
                                    </p>

                                    <p className="subtitle" style={{ textDecoration: strikethrough ? 'line-through' : 'none', fontWeight: 400, fontSize: '0.85rem', color: 'rgb(148, 163, 184)' }}>
                                      {maskCurrency(additinal.pricing)}
                                    </p>
                                  </div>
                                )
                              })
                            })}
                          </div>
                        ) : ""}
                      </div>
                    </div>

                    <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                      <p className="subtitle" style={{ fontWeight: 700 }}>{maskCurrency(canculateUnitProduct(productOrder) * productOrder.quantity)}</p>

                      <HiOutlinePrinter size={15} color="#7176f8" onClick={async () => await sendPrint('product-order', { dataProducts: [productOrder] }, order?.id)} />

                      {productOrder.isSeen ? <FaCheck color="green" /> : <MdClose className="pointer" onClick={async () => await setSeen(productOrder.id)} color="red" />}
                    </div>
                  </CustomItemCard>
                ))}
              </div>

            </>
          </div>
        ) : (orderScreen.listProducts || orderScreen.addProducts) ? (
          <NewAddProduct />
        ) : orderScreen.customer ? <CustomerForm onDirtyChange={setCustomerDirty} /> : orderScreen.closeOrder ? <AllPayments closeOrCancelOrder={closeOrCancelOrder} /> : ''}
      </OffCanvas >
    </>
  )
}
